import * as React from 'react';
let counter = 0;
export function guid(prefix = '') {
    counter += 1;
    return `${prefix}${counter}`;
}
export function useGuid(prefix = '') {
    const id = React.useRef(guid(prefix));
    return id.current;
}
